const emailRegex =
  /^[a-zA-Z0-9._%+-]+(?:\+[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/gm

const isEmailValid = (email: string) => emailRegex.test(email)

export default isEmailValid
